'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _Gromit = require('./Gromit');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *
 * Gromit Response Object
 *
 */
var GromitResponse = function () {

  /**
   *
   * Create a new Gromit resposne
   * @param {Object} responseData - Response data to build the response from
   * @param {ClientRequest|XMLHttpRequest} responseData.request - The request that created this response. Will be a `XMLHttpRequest` in the browser and `ClientRequest` in node.js
   * @param {any} responseData.data - The response data in whatever format the surver supplied it
   * @param {Object} headers - The response headers returned by the server
   * @param {number} statusCode - The status code returned by the server
   * @param {string} statusText - The status text returned by the server
   * @param {Gromit} [requester] - The instance Gromit that made the request (if applicable)
   */
  function GromitResponse(responseData, requester) {
    (0, _classCallCheck3.default)(this, GromitResponse);

    /**
     * The instance Gromit that made the request (if applicable)
     * @type {Gromit}
     */
    this.requester = requester;
    /**
     * The request that created this response. Will be a `XMLHttpRequest` in the browser and `ClientRequest` in node.js
     * @type {ClientRequest|XMLHttpRequest}
     */
    this.request = responseData.request;
    /**
     * The response data in whatever format the surver supplied it
     * @type {any}
     */
    this.data = responseData.data;
    /**
     * The response headers returned by the server
     * @type {Object}
     */
    this.headers = responseData.headers;
    /**
     * The status code returned by the server
     * @type {number}
     */
    this.statusCode = responseData.statusCode;
    /**
     * The status text returned by the server
     * @type {string}
     */
    this.statusText = responseData.statusText;
  }

  (0, _createClass3.default)(GromitResponse, null, [{
    key: 'fromAxiosResponse',
    value: function fromAxiosResponse(response, requester) {
      return new GromitResponse({
        request: response.request,
        data: response.data,
        headers: response.headers,
        statusCode: response.status,
        statusText: response.statusText
      }, requester);
    }
  }]);
  return GromitResponse;
}();

/**
 *
 * @module GromitResponse
 *
 */

exports.default = GromitResponse;